import React from 'react';
import Button from '@vfuk/core-button';
import Heading from '@vfuk/core-heading';
import { SubCategoryQuestionsProps } from '../../Types/SubCategoryQuestionsTypes';
import {
  ButtonsAreaWrapper,
  ButtonWrapper,
  HeadingWrapper,
} from '../../styles/SectionAssessmentAboutBusiness.styles';

const SubCategoryQuestion = ({
  content,
  getQuestionImage,
  firstsetquestions,
  subcategoriequestion,
  nextEvent,
}: SubCategoryQuestionsProps) => {
  return (
    <div id="carouselItem" className="question9">
      <img className="sureyQueImage" src={getQuestionImage(8)} />
      <div className="questionStyle">{`${content.questionNumberText1} ${
        firstsetquestions.length + 3
      } ${content.questionNumberText2} ${firstsetquestions.length + 3}`}</div>
      <HeadingWrapper>
        <Heading
          text={subcategoriequestion ? subcategoriequestion.catergory_name : ''}
          weight={2}
          size={2}
          noMargin={true}
        />
      </HeadingWrapper>
      <div className="asses-helper-text">{content.headingText[6]}</div>

      <ButtonsAreaWrapper>
        {subcategoriequestion &&
          subcategoriequestion.subcategories.map((q, i) => (
            <ButtonWrapper key={i}>
              <Button
                text={q.sub_category_name}
                appearance="alt1"
                onClick={e => {
                  nextEvent(
                    String(firstsetquestions.length + 2),
                    q.sub_category_name,
                    String(q.sc_id)
                  );
                  e.currentTarget.blur();
                }}
              />
            </ButtonWrapper>
          ))}
      </ButtonsAreaWrapper>
    </div>
  );
};

export default SubCategoryQuestion;
